<template>
  <modal v-if="visible" md-dynamic-height>
    <template slot="header">
      <div class="md-layout md-alignment-center-right">
        <div class="md-layout-item" style="padding-left: 0;">
          <h4>Search Diagnosis & ICD10</h4>
        </div>
        <div class="md-layout-item md-alignment-top-right">
          <md-icon class="exit-icon" style="color: red; float: right" @click.native="closeModal">cancel</md-icon>
        </div>
      </div>
    </template>
    <template slot="body">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-field>
            <label>Modality</label>
            <md-select v-model="selectedModality" :disabled="isCreate">
              <md-option v-for="modality in modalities" :key="modality" :value="modality">
                {{ modality }}
              </md-option>
            </md-select>
          </md-field>
          <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              margin-top: 0px;
              padding-top: 0px;
            "
          >
            <div style="width: 100%; display: flex; flex-direction: row; gap: 1rem">
              <md-field style="width: 70%">
                <label>Finding</label>
                <md-input v-model="findingInput" :disabled="isCreate"></md-input>
              </md-field>
              <md-field style="width: 20%">
                <label>Affected Eye</label>
                <md-select v-model="selectedEye" :disabled="isCreate">
                  <md-option v-for="eye in this.eyes" :key="eye" :value="eye">
                    {{ eye }}
                  </md-option>
                </md-select>
              </md-field>
            </div>

            <div style="height: 2.5rem; display: flex; flex-direction: row; gap: 1rem">
              <md-button class="md-raised md-primary md-sm" :disabled="isCreate" @click="searchDBCards"> Search </md-button>
            </div>
          </div>

          <md-field class="search-results">
            <label v-if="!localSearchResults">Search Results</label>
            <div v-if="isLoading" class="loading-container">
              <img style="margin: 0; padding: 0; width: 50px" src="@/assets/img/plswait2.gif" alt="Loading..." />
              <div style="margin-left: 5px;">
                {{ textLoading }}
              </div>
            </div>

            <div v-else class="results-container">
              <v-card v-if="this.localSearchResults && this.localSearchResults.type === 'search'" flat>
                <v-card-text v-if="this.localSearchResults.data.length > 0" style="padding: 0px">
                  <v-expansion-panels>
                    <v-expansion-panel
                      v-for="item in localSearchResults.data"
                      :key="item.id"
                      :class="{ 'selected-item': isSelected(item.id) }"
                      style="transition: all 0.3s"
                    >
                      <v-expansion-panel-header style="font-size: 0.85rem">
                        <template v-slot:default="{ open }">
                          <div style="display: flex; align-items: center; width: 100%">
                            <div style="margin-right: 12px" @click.stop="toggleSelection(item)">
                              <v-checkbox
                                :input-value="isSelected(item.id)"
                                color="primary"
                                hide-details
                                style="margin: 0; padding: 0"
                                @click.stop="toggleSelection(item)"
                              ></v-checkbox>
                            </div>
                            <span style="flex-grow: 1; text-align: left">
                              <span style="font-size: 0.81rem; color: #666"> {{ item.eye_affected }}&nbsp; </span>
                              <span>&nbsp; | &nbsp;</span>
                              <span style="font-size: 0.94rem">{{ item.observation }}</span>
                            </span>
                            <span style="font-size: 0.65rem; color: #7e7e7e; margin-left: 8px">
                              {{ open ? "hide details" : "view details" }}
                            </span>
                          </div>
                        </template>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card flat>
                          <v-card-text style="padding: 0 16px 16px">
                            <h4 class="section-title">Diagnoses</h4>
                            <div
                              v-for="(diagnosis, dIndex) in item.diagnoses"
                              :key="`diagnosis-${item.id}-${dIndex}`"
                              class="section-item"
                            >
                              {{ diagnosis.split("(")[0].trim() }} &nbsp;
                              <a
                                v-if="diagnosis.includes('(')"
                                :href="`https://www.icd10data.com/search?s=${diagnosis.split('(')[1].split(')')[0]}`"
                                target="_blank"
                                style="text-decoration: none"
                              >
                                <span style="color: #1976d2">({{ diagnosis.split("(")[1].split(")")[0] }})</span>
                              </a>
                            </div>

                            <h4 class="section-title" style="margin-top: 1rem">Recommendations</h4>
                            <ul class="recommendation-list">
                              <li
                                v-for="(recommendation, rIndex) in item.recommendations"
                                :key="`recommendation-${item.id}-${rIndex}`"
                                class="section-item"
                              >
                                {{ recommendation }}
                              </li>
                            </ul>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                      <v-divider></v-divider>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
                <v-card-text v-else style="padding: 0px">
                  <div
                    style="
                      background-color: #ffffff;
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: center;
                      margin-top: 1rem;
                    "
                  >
                    <h4 style="color: #666; font-weight: 400; margin-bottom: 1.5rem">
                      <md-icon style="color: #ff9800; vertical-align: middle">info</md-icon>
                      Diagnosis not found. Search again or generate a new one
                    </h4>
                    <div style="display: flex; flex-direction: row; gap: 1rem; margin-left: 8px">
                      <md-button class="md-raised md-primary md-dense" @click="submitDxSearch()">
                        Generate Diagnosis
                      </md-button>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
              <v-card v-if="this.localSearchResults && this.localSearchResults.type === 'clinical'" flat>
                <v-card-text style="padding: 0px">
                  <h3>{{ this.localSearchResults.data.modality }}: &nbsp;{{ this.localSearchResults.data.finding }}</h3>

                  <h4 class="title1">Clinical Explanation:</h4>
                  <ul
                    v-if="this.localSearchResults && this.localSearchResults.data.clinical_explanation"
                    class="no-bullets"
                    style="margin-left: 10px"
                  >
                    <li>
                      <u>Characteristics</u>:&nbsp;
                      {{ this.localSearchResults.data.clinical_explanation.characteristics }}
                    </li>
                    <li>
                      <u>Clinical Scenarios</u>:&nbsp;
                      {{ this.localSearchResults.data.clinical_explanation.clinical_scenarios }}
                    </li>
                    <li><u>Indication</u>:&nbsp;{{ this.localSearchResults.data.clinical_explanation.indication }}</li>
                    <li><u> Variants</u>:&nbsp;{{ this.localSearchResults.data.clinical_explanation.variants }}</li>
                  </ul>

                  <h4 class="title1">Associated ICD10 Codes:</h4>
                  <ul
                    v-if="this.localSearchResults && this.localSearchResults.data.clinical_explanation"
                    class="no-bullets"
                    style="margin-left: 10px"
                  >
                    <li v-for="(icd10, index) in this.localSearchResults.data.icd10_codes" :key="index">
                      <a :href="`https://www.icd10data.com/search?s=${icd10.code}`" target="_blank">
                        ({{ icd10.code }})
                      </a>
                      {{ icd10.description }}
                      (<i>{{ icd10.relevance }}</i
                      >)
                    </li>
                  </ul>
                </v-card-text>
              </v-card>
              <v-card v-if="localSearchResults.data && localSearchResults.data.error" flat>
                <div
                    style="
                      background-color: #ffffff;
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: center;
                      margin-top: 1rem;
                    "
                  >
                    <h4 style="color: #666; font-weight: 400; margin-bottom: 1.5rem">
                      <md-icon style="color: #ff9800; vertical-align: middle">info</md-icon>
                      We could not generate any DX card for this search criteria
                    </h4>
                  </div>
                </v-card>
              <v-card v-if="this.localSearchResults && this.searchFormat == 'CARD'" flat></v-card>
            </div>
          </md-field>

          <div v-if="this.localSearchResults.type === 'clinical'" class="md-layout md-alignment-center-right">
            <md-button class="md-raised md-primary md-sm" @click="submitDxGenerate"> Save Dx Card </md-button>
          </div>
          <div v-if="this.localSearchResults.type === 'search'" class="md-layout md-alignment-center-right">
            <md-button class="md-raised md-primary md-sm" @click="addDiagnosis"> Add Diagnosis </md-button>
          </div>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import { Modal } from "@/components"
import { mapGetters, mapActions } from "vuex"
import { bus } from "@/main"

export default {
  name: "DxSearch",
  components: { Modal },
  data() {
    return {
      selectedModality: "",
      selectedEye: "",
      findingInput: "",
      searchFormat: "",
      modalities: [
        "External Photo",
        "Corneal Topography",
        "Anterior Segment OCT",
        "Lens Status",
        "Fundus Photo",
        "Macular OCT",
        "Optic Nerve OCT"
      ],
      eyes: ["OU", "OS", "OD"],
      textLoading: ''
    }
  },
  props: {
    visible: Boolean,
    isLoading: Boolean,
    selectedCards: Array,
    searchResults: Object,
    isCreate: Boolean,
  },
  computed: {
    ...mapGetters(["dxOptionsList", "createFinding", "screening"]),
    localIsLoading: {
      get() {
        return this.isLoading
      },
      set(val) {
        this.$emit("updateLoading", val)
      }
    },

    localSelectedCards: {
      get() {
        return this.selectedCards
      },
      set(val) {
        this.$emit("update:selectedCards", val)
      }
    },

    localSearchResults: {
      get() {
        return this.searchResults
      },
      set(val) {
        this.$emit("update:searchResults", val)
      }
    }
  },
  mounted: function () {
    this.selectedModality = this.modalities[0]
    this.selectedEye = this.eyes[0]

    if (this.isCreate) {
      this.selectedEye = this.createFinding.finding.eyeAffected;
      this.findingInput = this.createFinding.finding.name;
      this.selectedModality = this.createFinding.finding.modality;
      this.submitDxSearch();
    }
  },
  methods: {
    ...mapActions(["updateCreateFinding"]),
    closeModal(data = {}) {
      if (this.isCreate) {
        data.eyeAffected = this.selectedEye;
        this.selectedModality = this.modalities[0];
        this.selectedEye = this.eyes[0];
        this.findingInput = '';
        this.updateCreateFinding({isCreate: false, finding: data, sectionName: this.createFinding.sectionName});
      }
      this.$emit("closeModal")
    },
    searchDBCards() {
      this.localSearchResults = { type: "search", data: [] }
      this.localIsLoading = true

      const url = `${String(process.env.VUE_APP_URL)}/dx-cards/dxSearch`
      const config = {
        headers: { "Content-Type": "application/json" },
        params: { term: this.findingInput, eye_affected: this.selectedEye, modality: this.selectedModality }
      }
      window.axios
        .get(url, config)
        .then((response) => {
          this.localSearchResults = {
            type: "search",
            data: response.data
          }
          this.localIsLoading = false
        })
        .catch((error) => {
          this.localSearchResults = { type: "search", data: [] }
          this.localIsLoading = false
        })
    },
    submitDxSearch() {
      this.searchFormat = "CLINICAL"
      this.localSearchResults = {}
      this.localIsLoading = true
      this.textLoading = 'Searching for a new Dx/Findings card';

      const url = `${String(process.env.VUE_APP_URL).replace("/api/v1", "")}/ai/claude/clinical`
      const payload = {
        modality: this.selectedModality,
        finding: this.findingInput,
        eye_affected: this.selectedEye
      }
      window.axios
        .post(url, payload)
        .then((response) => {
          this.localSearchResults = {
            type: "clinical",
            data: response.data
          }
        })
        .catch((error) => {
          this.localSearchResults.data = {error:true}
          console.log(error)
        }).finally(()=>{
          this.localIsLoading = false
          this.textLoading = '';
        })
    },
    addDiagnosis() {
      this.localIsLoading = true
      const newItems = this.selectedCards
        .map((card) => ({
          REQ: `${card.id}.${card.eye_affected}`,
          RSLT: { ...card }
        }))
        .filter((newItem) => !this.dxOptionsList.some((existing) => existing.RSLT.id === newItem.RSLT.id))

      if (newItems.length) {
        this.$store.commit("UPDATE_DX_OPTIONS", [...this.dxOptionsList, ...newItems])
        
      }
      this.localIsLoading = false
      this.closeModal()
      this.localSelectedCards = []
      this.localSearchResults = {}

      bus.$emit("dxOptionsChanged", true)
    },
    submitDxGenerate() {
      this.searchFormat = "CARD"
      this.localSearchResults = {}
      this.textLoading = 'Generating a new card';
      this.localIsLoading = true
      const url = `${String(process.env.VUE_APP_URL).replace("/api/v1", "")}/ai/claude/dxrec`
      const data = {
        modality: this.selectedModality,
        finding: this.findingInput,
        eye_affected: this.selectedEye,
        instruct_DX: `speak in definite terms regarding diagnoses. do not use vague or ambious expressions like 'possible' or 'likely'.
          THEN find the most relevent ICD-10 code matching the diagnosis and append just the CODE to the diagnosis in prenthesis.`,
        instruct_REC: `Do not mention specific testing in patient follow up. Do not use language like 'in the meantime'.
          In general a bad recommentaiton would be: 'Discuss surgical options like intracorneal ring segments if your vision is significantly affected.'.
          BETTER would be: 'if you vision is signicantly affected, recommend in an office evaluation.'
          If intervention or surgery is requred then recommend an in office exam for further evaluation.
          Don't say 'I recommend', just provide the recommendation, such as 'please schedule,' or 'follow up with', etc.
          Don't say 'an in-office visit can help...'  be emphatic. Instead, sayt 'schedule an in-office visit ...'.`,
        temp: 0.1,
        orgId: this.screening.orgID
      }

      window.axios.post(url, data).then((response) => {
        this.localSearchResults = {
          type: "save",
          data: response.data
        }

        const updatedList = [...this.dxOptionsList]
        updatedList.push(response.data)
        this.$store.commit("UPDATE_DX_OPTIONS", updatedList)
        this.textLoading = '';
        bus.$emit("dxOptionsChanged", true)
        this.localIsLoading = false
        this.closeModal(response.data.RSLT)
      })
    },
    toggleSelection(item) {
      const index = this.selectedCards.findIndex((card) => card.id === item.id)
      const newSelectedCards = [...this.selectedCards]
      if (index > -1) {
        newSelectedCards.splice(index, 1)
      } else {
        newSelectedCards.push({ id: item.id, ...item })
      }

      this.$emit("update:selectedCards", newSelectedCards)
    },
    isSelected(id) {
      return this.selectedCards.some((card) => card.id === id)
    }
  }
}
</script>
<style scoped lang="scss">
.title1 {
  text-align: left;
  font-size: 0.96rem;
  color: black;
  font-weight: 400;
  margin-top: 16px;
  margin-bottom: 6px;
}

.exit-icon {
  cursor: pointer;
  margin: 0px;
  padding: 0px;
}
.search-results {
  margin-top: 20px;

  .results-container {
    height: 300px;
    width: 100%;
    overflow-y: auto;
    background-color: #ffffff;
    padding: 8px;
    margin-top: 0px;
    text-align: left;
    border: 1px solid #ddd;
    border-radius: 4px;

    // Add spacing for major sections
    > div {
      margin-bottom: 24px;
    }

    h3 {
      margin-top: 20px;
      margin-bottom: 12px;
    }

    ul {
      margin-top: 12px;
      margin-bottom: 16px;
    }

    li {
      margin-bottom: 6px;
    }

    p {
      margin-bottom: 15px;
      font-weight: 600;
      font-size: larger;
    }

    .no-bullets,
    .no-bullets li {
      list-style-type: none;
    }
  }
}

.md-field {
  margin-bottom: 16px;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-top: 8px;
  width: 100%;
}
.section-title {
  color: #424242;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.section-item {
  font-size: 0.8rem;
  margin-bottom: 0.3rem;
}

.recommendation-list {
  list-style-type: disc;
  padding-left: 1.5rem;
  margin-top: 0;
}
.selected-item {
  background-color: #f5faff;
  border-left: 3px solid #1976d2;
}
</style>
